import type { GameState, IndicatorKey } from '../../types/simulation.js';
import { MAX_HISTORY_POINTS_PER_INDICATOR } from '../../config/game.js';

export const recordHistory = (state: GameState, at = state.clock.currentTime): void => {
  const keys = Object.keys(state.indicators) as IndicatorKey[];
  for (const key of keys) {
    state.history.push({ at, key, value: state.indicators[key].value });
  }
  compactHistory(state);
};

export const compactHistory = (state: GameState): void => {
  const groups = new Map<IndicatorKey, typeof state.history>();
  for (const point of state.history) {
    const list = groups.get(point.key) ?? [];
    list.push(point);
    groups.set(point.key, list);
  }

  const compacted: typeof state.history = [];
  for (const list of groups.values()) {
    if (list.length <= MAX_HISTORY_POINTS_PER_INDICATOR) {
      compacted.push(...list);
      continue;
    }
    const old = list.slice(0, list.length - Math.floor(MAX_HISTORY_POINTS_PER_INDICATOR * 0.7));
    const recent = list.slice(list.length - Math.floor(MAX_HISTORY_POINTS_PER_INDICATOR * 0.7));
    const bucketSize = Math.max(2, Math.ceil(old.length / Math.floor(MAX_HISTORY_POINTS_PER_INDICATOR * 0.3)));
    for (let index = 0; index < old.length; index += bucketSize) {
      const bucket = old.slice(index, index + bucketSize);
      compacted.push({
        at: bucket[bucket.length - 1].at,
        key: bucket[0].key,
        value: bucket.reduce((sum, point) => sum + point.value, 0) / bucket.length
      });
    }
    compacted.push(...recent);
  }
  state.history = compacted.sort((a, b) => Date.parse(a.at) - Date.parse(b.at));
};
